var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toToBox",attrs:{"id":"toToBoxDiv"}},[_c('topImg',{attrs:{"imgHeight":_vm.imgHeight,"background":_vm.background,"showInput":false}}),_c('onlyContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }